import React from 'react'
import './style.css'

export const Timer = ({ counter = 3 }) => {
  return (
    <div className="container-timer">
      <p>Reenviar SMS em</p>
      <div className="timer">
        <span>{counter}</span>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
